import { Routes } from '@angular/router';
import { JsaComponent } from './pages/safety-group/forms/jsa-form/jsa.component';
import { BaseLayoutComponent } from './base-layout/base-layout.component';
import { JsaPaperComponent } from './pages/safety-group/forms/jsa-paper-form/jsa-paper.component';
import { ReportsComponent } from './pages/safety-group/apps/reports/reports.component';
import { NearMissComponent } from './pages/safety-group/forms/near-miss-form/near-miss.component';
import { GoodCatchComponent } from './pages/safety-group/forms/good-catch-form/good-catch.component';
import { SuccessComponent } from './pages/safety-group/success/form-success.component';
import { DownloadPdfComponent } from './pages/safety-group/apps/download-pdf/download-pdf.component';
import { HubComponent } from './hub/hub.component';
import { SafetyComponent } from './pages/safety/safety.component';
import { MsalGuard } from '@azure/msal-angular';
import { FailedComponent } from './pages/x-misc/failed/failed.component';
import { AuthHandleComponent } from './auth-handle/auth-handle.component';
import { RedirectComponent } from './redirect/redirect.component';
import { HumanResourcesComponent } from './pages/human-resources/human-resources.component';
import { StandardsComponent } from './pages/standards/standards.component';
import { WeatherComponent } from './pages/weather/weather.component';
import { TravelComponent } from './pages/travel/travel.component';
import { AppHubComponent } from './pages/app-hub/app-hub.component';
import { ExportExcelComponent } from './pages/safety-group/apps/export-excel/export-excel.component';
import { ComponentAccessGuard } from './auth.component-guard';
import { SuperAdminGuard } from './auth.super-admin-guard';
import { BlockedUserGuard } from './auth.blocked-user-guard';
import { UnauthorizedComponent } from './pages/x-misc/unauthorized/unauthorized.component';
import { StandformsComponent } from './pages/standards-group/standards-forms/standforms.component';
import { NewsletterArchiveComponent } from './pages/hub-extensions/newsletter-archive/newsletter-archive.component';
import { TrainingReqComponent } from './pages/training-req/training-req.component';
import { SseChecklistComponent } from './pages/sse-group/sse-checklist/sse-checklist.component';
import { SseIndexComponent } from './pages/sse-group/sse-index/sse-index.component';
import { SseHubComponent } from './pages/sse-group/sse-hub/sse-hub.component';
import { GuidesComponent } from './pages/standards-group/guides/guides.component';
import { SafetyAnalyticsComponent } from './pages/safety-group/apps/safety-analytics/safety-analytics.component';
import { DownloadPdfGcComponent } from './pages/safety-group/apps/download-pdf-gc/download-pdf-gc.component';
import { DownloadPdfNmComponent } from './pages/safety-group/apps/download-pdf-nm/download-pdf-nm.component';
import { PrivacyPolicyComponent } from './pages/x-misc/privacy-policy/privacy-policy.component';
import { DownloadPdfAccidentComponent } from './pages/safety-group/apps/download-pdf-accident/download-pdf-accident.component';
import { FeedbackComponent } from './pages/feedback/feedback.component';
import { InformationTechnologyComponent } from './pages/information-technology/information-technology.component';
import { MarketingComponent } from './pages/marketing/marketing.component';
import { ItFormHubComponent } from './pages/information-technology/forms/it-form-hub/it-form-hub.component';
import { EquipmentRequestFormComponent } from './pages/information-technology/forms/equipment-request-form/equipment-request-form.component';
import { FirstAidFormComponent } from './pages/safety-group/forms/first-aid-form/first-aid-form.component';
import { FieldBooksComponent } from './pages/standards-group/field-books/field-books.component';
import { FieldBookLogsComponent } from './pages/standards-group/field-book-logs/field-book-logs.component';
import { TrainingHubComponent } from './pages/training-group/training-hub/training-hub.component';
import { TrainingModuleComponent } from './pages/training-group/training-module/training-module.component';
import { LearningLandingComponent } from './pages/training-group/learning-landing/learning-landing.component';
export const routes: Routes = [
  {
    path: 'redirect',
    component: RedirectComponent,
  },
  {
    path: 'auth',
    component: AuthHandleComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'training/:id',
    component: TrainingModuleComponent,
    canActivate: [MsalGuard, BlockedUserGuard],
  },
  {
    path: '',
    component: BaseLayoutComponent,
    canActivateChild: [BlockedUserGuard],
    children: [
      {
        path: '',
        component: HubComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'success',
        component: SuccessComponent,
      },
      {
        path: 'jsa-paper',
        component: JsaPaperComponent,
        // MsalGuard guarantees an account (interactive login if none) before the form is
        // shown. Paired with the fail-closed AuthInterceptor (blocks token-less submits +
        // recovers C3 at submit with a preserved draft) — Option B, no custom entry guard.
        canActivate: [MsalGuard],
      },
      {
        path: 'miss',
        component: NearMissComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'catch',
        component: GoodCatchComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'general-admin' },
      },
      {
        path: 'pdf-download',
        component: DownloadPdfComponent,
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'general-admin' },
      },
      {
        path: 'pdf-download-gc',
        component: DownloadPdfGcComponent,
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'safety-admin' },
      },
      {
        path: 'pdf-download-nm',
        component: DownloadPdfNmComponent,
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'safety-admin' },
      },
      {
        path: 'pdf-download-accident',
        component: DownloadPdfAccidentComponent,
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'safety-admin' },
      },
      {
        path: 'jsa',
        component: JsaComponent,
        // MsalGuard guarantees an account (interactive login if none). A present-but-dead
        // token (C3) now surfaces at submit via the fail-closed AuthInterceptor, which
        // escalates interaction-required to acquireTokenRedirect with the draft preserved —
        // so the custom entry-time AcquireTokenGuard is no longer needed. Option B: matches
        // the other four safety-form routes.
        canActivate: [MsalGuard],
      },
      {
        path: 'safety',
        component: SafetyComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'marketing',
        component: MarketingComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'login-failed',
        component: FailedComponent,
      },
      {
        path: 'human-resources',
        component: HumanResourcesComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'standards',
        component: StandardsComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'procedures',
        component: StandformsComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'guides',
        component: GuidesComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'weather',
        component: WeatherComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'travel',
        component: TravelComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'app-hub',
        component: AppHubComponent,
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'general-admin' },
      },
      {
        path: 'export-excel',
        component: ExportExcelComponent,
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'general-admin' },
      },
      {
        path: 'safety-analytics',
        component: SafetyAnalyticsComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'jsa-analytics',
        redirectTo: 'safety-analytics',
        pathMatch: 'full',
      },
      {
        path: 'newsletter-archive',
        component: NewsletterArchiveComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'training-req',
        component: TrainingReqComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'sse-checklist',
        component: SseChecklistComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'sse-checklist/:id',
        component: SseChecklistComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'sse-index',
        component: SseIndexComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'sse-index/:id',
        component: SseIndexComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'sse-hub',
        component: SseHubComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent,
      },
      {
        path: 'feedback',
        component: FeedbackComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'computer-request-form',
        component: EquipmentRequestFormComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'information-technology',
        component: InformationTechnologyComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'it-form-hub',
        component: ItFormHubComponent,
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'it-forms-admin' },
      },
      {
        path: 'computer-request-form/:id',
        component: EquipmentRequestFormComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'first-aid-form/:id',
        component: FirstAidFormComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'first-aid-form',
        component: FirstAidFormComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'field-book-numbers',
        component: FieldBooksComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'field-book-logs',
        component: FieldBookLogsComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'email-recipients',
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'email-admin' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/administration/email-recipients/email-recipients.component')
                .then(m => m.EmailRecipientsComponent),
            canActivate: [MsalGuard, ComponentAccessGuard],
            data: { requiredComponent: 'email-admin' },
          },
          {
            path: ':formId',
            loadComponent: () =>
              import('./pages/administration/email-recipients/email-recipients-detail.component')
                .then(m => m.EmailRecipientsDetailComponent),
            canActivate: [MsalGuard, ComponentAccessGuard],
            data: { requiredComponent: 'email-admin' },
          },
        ],
      },
      {
        path: 'documents-admin',
        loadComponent: () =>
          import('./pages/administration/documents-admin/documents-admin.component')
            .then(m => m.DocumentsAdminComponent),
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'documents-admin' },
      },
      {
        path: 'documents-admin/recycle-bin',
        loadComponent: () =>
          import('./pages/administration/documents-admin/recycle-bin/recycle-bin.component')
            .then(m => m.RecycleBinComponent),
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'documents-admin' },
      },
      {
        path: 'news-admin',
        loadComponent: () =>
          import('./pages/administration/news-admin/news-admin.component')
            .then(m => m.NewsAdminComponent),
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'news-admin' },
      },
      {
        path: 'learning',
        component: LearningLandingComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'training',
        component: TrainingHubComponent,
        canActivate: [MsalGuard],
      },
      {
        path: 'admin',
        loadComponent: () =>
          import('./pages/administration/admin-hub/admin-hub.component')
            .then(m => m.AdminHubComponent),
        canActivate: [MsalGuard],
      },
      {
        path: 'training-modules-admin',
        loadComponent: () =>
          import('./pages/administration/training-modules-admin/training-modules-admin.component')
            .then(m => m.TrainingModulesAdminComponent),
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'training-admin' },
      },
      {
        path: 'training-modules-admin/:id',
        loadComponent: () =>
          import('./pages/administration/training-modules-admin/training-module-edit/training-module-edit.component')
            .then(m => m.TrainingModuleEditComponent),
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'training-admin' },
      },
      {
        path: 'safety-counter-admin',
        loadComponent: () =>
          import('./pages/administration/safety-counter-admin/safety-counter-admin.component')
            .then(m => m.SafetyCounterAdminComponent),
        canActivate: [MsalGuard, ComponentAccessGuard],
        data: { requiredComponent: 'safety-counter-admin' },
      },
      {
        path: 'access-control-admin',
        loadComponent: () =>
          import('./pages/administration/access-control-admin/access-control-admin.component')
            .then(m => m.AccessControlAdminComponent),
        canActivate: [MsalGuard, SuperAdminGuard],
      },
    ],
  },
];
